import React from 'react';
import type { LinkedObject } from '../types';
import { AcademicConnectionsView } from './AcademicConnectionsView';

interface RoleAcademicConnectionsOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  roleContext: string;
  roleTitle?: string;
  userRoleCodes?: string[];
  onOpenLinkedObject?: (linkedObject: LinkedObject) => void;
  initialTarget?: {
    userId?: string;
    academiaId?: string;
    role?: string;
    linkedObject?: LinkedObject;
  };
}

export const RoleAcademicConnectionsOverlay: React.FC<RoleAcademicConnectionsOverlayProps> = ({
  isOpen,
  onClose,
  roleContext,
  roleTitle,
  userRoleCodes,
  onOpenLinkedObject,
  initialTarget,
}) => {
  if (!isOpen) return null;

  return (
    <AcademicConnectionsView
      roleContext={roleContext}
      roleTitle={roleTitle}
      userRoleCodes={userRoleCodes}
      onBack={onClose}
      onClose={onClose}
      onOpenLinkedObject={onOpenLinkedObject}
      initialTarget={initialTarget}
    />
  );
};
